import React, { Component} from 'react';
import ReactDOM from 'react-dom';

class Modal extends Component {
    constructor(props) {
        super(props);
        this.modalRoot = document.querySelector('.modal-root');
        this.el = document.createElement('div');
    }

    componentDidMount() {
        this.modalRoot.appendChild(this.el);
    }

    componentWillUnmount() {
        this.modalRoot.removeChild(this.el);
    }

    render() {
        return ReactDOM.createPortal (
            <div className="modal">
                {this.props.children}
            </div>,
            this.el
        )
    }
}

export default Modal;